import React from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import App from './App'
// import registerServiceWorker/*, { unregister }*/ from './registerServiceWorker'
import './style/global'
// import 'semantic-ui-css/semantic.min.css'
import 'semantic-ui-css/components/transition.min.css'
import 'semantic-ui-css/components/icon.min.css'
import 'semantic-ui-css/components/grid.min.css'
import 'semantic-ui-css/components/header.min.css'
import 'semantic-ui-css/components/image.min.css'
import 'semantic-ui-css/components/button.min.css'
import 'semantic-ui-css/components/dropdown.min.css'
import 'semantic-ui-css/components/form.min.css'
import 'semantic-ui-css/components/input.min.css'
import 'semantic-ui-css/components/modal.min.css'
import 'semantic-ui-css/components/message.min.css'

const rootEl = document.getElementById('root')
ReactDOM.render(<I18nextProvider i18n={i18n}><App /></I18nextProvider>, rootEl)
document.querySelector('html').setAttribute('lang', i18n.language)
// registerServiceWorker()
// unregister()

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(<I18nextProvider i18n={i18n}><NextApp /></I18nextProvider>, rootEl)
  })
}



// WEBPACK FOOTER //
// ./src/index.js